const coproForm = document.getElementById('reklamasjonsskjema');
const coproFormStatusContainer = document.getElementById('copro-form-status');

const ReklamasjonsSkjema = {

    registerClick: () => {
        coproForm.addEventListener('submit', function (e) {
            e.preventDefault();
            ReklamasjonsSkjema.sendDeviationRequest();
        });
    },

    sendDeviationRequest: () => {
        const credentials = btoa(process.env.MIX_COPRO_API_CREDENTIALS);
        const API_URL = process.env.MIX_COPRO_APIURL;

        const formData = new FormData(document.getElementById('reklamasjonsskjema'));
        const formObject = {};
        formData.forEach((value, key) => {
            formObject[key] = value;
        });

        if (
            formObject['copro-tittel'] === '' ||
            formObject['copro-navn'] === '' ||
            formObject['copro-date_of_occurrence'] === '' ||
            formObject['copro-telefon'] === '' ||
            formObject['copro-email'] === '' ||
            formObject['copro-beskrivelse'] === '' ||
            formObject['copro-hendelssted'] === '') {
                coproFormStatusContainer.classList.add('active');
                coproFormStatusContainer.innerHTML = 'Vennligst fyll ut alle feltene i skjemaet.';
                return;
        }

        const requestBody = {
            "schemaName": "Kunde- og leverandørklage",
            "title": formObject['copro-tittel'],
            "date_of_occurrence": formObject["copro-date_of_occurrence"],
            "Customer": formObject['copro-navn'],
            "Navn": formObject['copro-navn'],
            "Telefonnummer": formObject['copro-telefon'],
            "Epost": formObject['copro-email'],
            "description": formObject['copro-beskrivelse'],
            "Hendelssted": formObject['copro-hendelssted']
        };

        async function postData(url = '', data = {}) {
            try {
                const response = await fetch(url, {
                    method: 'POST',
                    headers: {
                        'Access-Control-Allow-Methods': 'POST, GET, OPTIONS, PUT',
                        'Access-Control-Allow-Origin': '*',
                        'Authorization': 'Basic ' + credentials,
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify(data)
                });
                return await response.text();
            } catch (error) {
                console.error(error);
                throw new Error('Network request failed');
            }
        }

        (async () => {
            try {
                const result = await postData(API_URL, requestBody);
                //console.log(result);
                coproFormStatusContainer.classList.add('active');
                const jsonResult = JSON.parse(result);
                if (jsonResult.deviationId !== null) {
                    //console.log("success: " + jsonResult.deviationId);
                    coproForm.style.display = 'none';
                    coproFormStatusContainer.innerHTML = 'Reklamasjonen ble sendt. <br>Ditt referansenummer er: ' + jsonResult.deviationId;
                } else {
                    coproFormStatusContainer.innerHTML = 'Det oppstod en feil under sending av reklamasjonen. Vennligst prøv igjen senere.';
                }
            } catch (error) {
                console.error(error);
                coproForm.reset();
                coproFormStatusContainer.innerHTML = 'Det oppstod en feil under sending av reklamasjonen. Vennligst prøv igjen senere.';
            }
        })();

    },

    init: () => {
        ReklamasjonsSkjema.registerClick();
    }

}

export default ReklamasjonsSkjema;